import script from "./DigitalProductStartDate.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./DigitalProductStartDate.vue?vue&type=script&lang=js"
export * from "./DigitalProductStartDate.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./DigitalProductStartDate.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"src/SharedWeb/scripts/dynamic-component-editor/standard-components/digital-product-card/DigitalProductStartDate.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4b9d1a0a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4b9d1a0a', __exports__)) {
    api.reload('4b9d1a0a', __exports__)
  }
  
}


export default __exports__